module.exports = __webpack_public_path__ + "static/media/arrows-left.50dccae6.svg";